import { render, staticRenderFns } from "./StatisticsModal.vue?vue&type=template&id=1dd6bf16&"
import script from "./StatisticsModal.vue?vue&type=script&lang=js&"
export * from "./StatisticsModal.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./StatisticsModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports